export default __webpack_public_path__ + "static/media/AIS2.50a01b3e.png";